import { RouterProvider } from "react-router-dom";
import { AuthProvider } from "@/hooks/useAuth";
import { ReferenceProvider } from "@/hooks/useReference";
import { ToastProvider } from "@/hooks/useToast";
import { Toaster } from "@/components/ui/Toaster";
import { router } from "@/routes";

export function App() {
  return (
    <ToastProvider>
      <AuthProvider>
        <ReferenceProvider>
          <RouterProvider router={router} />
          <Toaster />
        </ReferenceProvider>
      </AuthProvider>
    </ToastProvider>
  );
}
